// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'

function glightbox() {
  GLightbox()
}

export default glightbox;